import { render, staticRenderFns } from "./text-area.component.vue?vue&type=template&id=75f6d631&scoped=true&"
import script from "./text-area.component.vue?vue&type=script&lang=ts&"
export * from "./text-area.component.vue?vue&type=script&lang=ts&"
import style0 from "./text-area.component.vue?vue&type=style&index=0&id=75f6d631&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f6d631",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
